// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvaFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/salvaFranquia
 *
 * Returns the single franquia record persisted by the create/update write,
 * re-SELECTed and mapped by Franquias_model::salvaFranquia(). The `dados`
 * envelope field IS this row object.
 */
import type { Franquias_SalvaFranquiaRow } from './Franquias_SalvaFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Franquias_SalvaFranquiaResponseDados = Franquias_SalvaFranquiaRow;

export type Franquias_SalvaFranquiaResponse = ApiResponse<Franquias_SalvaFranquiaResponseDados>;

registerResponseContract('Franquias_SalvaFranquiaResponse', {
  ID:        { type: 'number',  required: false },
  Nome:      { type: 'string',  required: false },
  Email:     { type: 'string',  required: false },
  CNPJ:      { type: 'string',  required: false },
  Pais:      { type: 'string',  required: false },
  Idioma:    { type: 'string',  required: false },
  CreatedAt: { type: 'string',  required: false },
  UpdatedAt: { type: 'string',  required: false },
})
